import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { listTransition } from 'src/app/theme/utils/app-animation';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu, defaultMenuId } from 'src/app/shared/responses/imenu';
import { defaultHomeMenuId } from 'src/app/shared/utils/utility.common';
import * as debug from 'src/app/shared/services/debug.service';

@Component({
	selector: 'app-horizontal-menu',
	templateUrl: './horizontal-menu.component.html',
	styleUrls: ['./horizontal-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	animations: [listTransition],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorizontalMenuComponent implements OnInit {

	@Input() menuParentId: number;
	@Input() menuItems: IMenu[];

	defaultHomeMenuId = defaultHomeMenuId;

	settings: Settings;
	defaultMenuId = defaultMenuId;

	constructor(public appSettings: AppSettings, public menuService: MenuService) {
		this.settings = this.appSettings.settings;
	}

	ngOnInit() {
		this.menuItems = this.menuService.menus;
	}

	allowTransition(routerLink: string): boolean {
		const isCurrentUrl = this.menuService.isCurrentUrl(routerLink);
		return !isCurrentUrl;
	}

	scrollTo(menu: IMenu) {
		const id = menu.routerLink.replace('/', '');
		debug.warn(`scrollTo: ${id}`);
		this.menuService.scrollTo(id, 'HorizontalMenuComponent.scrollTo');
	}
}
